<template>
  <dv-border-box-8 class="merch" :dur="4" :reverse="true" backgroundColor="rgba(8, 50, 78, 0.6)">
    <PartTitle title="热门商品" />
    <!-- dataV 组件滚动方案 -->
    <!-- <dv-scroll-board class="scroll-board" :config="scrollBoardConfig" /> -->

    <!-- 自制滚动方案 -->
    <div class="merch-scroll">
      <div class="tab-hd">
        <span>&nbsp;</span>
        <span>商品</span>
        <span>生产企业</span>
        <span>销售价格</span>
      </div>
      <div class="tab-bd">
        <div
          class="row"
          v-for="(item, index) in currentPageList"
          :key="index"
          :class="{ active: activeIndex === currentPage * pageSize + index }">
          <div class="simple">
            <span>{{ currentPage * pageSize + index + 1 }}</span>
            <span>{{ item.merchName }}</span>
            <span>{{ item.ownerOrganName }}</span>
            <span>￥{{ getMerchPriceView(item) }}</span>
          </div>
          <div class="detail-wrap">
            <div class="detail">
              <img class="image" :src="item.imageUrl" alt="" />
              <div class="sku-des">
                <p>{{item.merchName}}</p>
                <p v-if="item.merchSkuName">规格：{{item.merchSkuName}}</p>
                <!-- <p>SPU码：YZ95071-01-07</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dv-border-box-8>
</template>

<script>
import PartTitle from './PartTitle.vue';
import { ssoApiUrl, fileApiUrl } from '@/utils/request'

export default {
  name: 'Merch',
  components: { PartTitle },
  data() {
    return {
      // dataV 滚动方案需要的数据
      // scrollBoardConfig: {
      //   header: ['商品', '生产企业', '销售价格'],
      //   data: [
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //     ['筇竹双层茶棚', '云南', '1400'],
      //   ],
      //   rowNum: 8,
      //   headerBGC: 'none',
      //   headerHeight: 40,
      //   oddRowBGC: 'rgba(142,201,255,0.2)',
      //   evenRowBGC: 'rgba(142,201,255,0.1)',
      //   index: true,
      //   waitTime: 2000,
      //   columnWidth: [60, 180, 100, 100],
      //   align: ['center', 'center', 'center', 'center'],
      // },

      activeIndex: 0, // 当前激活的项目索引
      currentPage: 0, // 当前显示的页码
      pageSize: 5, // 每页显示条数
      merchList: [

      ],
      timerId: null,
      time: null
    };
  },
  computed: {
    // 计算当前页的数据
    currentPageList() {
      const start = this.currentPage * this.pageSize;
      return this.merchList.slice(start, start + this.pageSize);
    },
    // 总页数
    totalPage() {
      return Math.ceil(this.merchList.length / this.pageSize);
    },
  },
  async created() {
    await this.loadMerchData();
    this.loadOrganData();
    this.loadMerchCover();



    this.$nextTick(() => {
      this.onScrollAndActive();
    })
  },

  mounted() {
    // if (this.time) {
    //   clearInterval(this.time);
    // }
    // this.time = setInterval(async () => {
    //   await this.loadMerchData();
    //   this.loadOrganData();
    //   this.loadMerchCover();
    // },5000)
  },

  methods: {
    // 商品滚动切换效果
    onScrollAndActive() {
      if (this.merchList.length <= this.pageSize) return;

      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        // 激活索引递增
        this.activeIndex = (this.activeIndex + 1) % this.merchList.length;

        // 计算当前应该显示的页码
        const newPage = Math.floor(this.activeIndex / this.pageSize);
        if (newPage !== this.currentPage) {
          this.currentPage = newPage;
        }
        // console.log(`当前激活第${this.activeIndex + 1}条数据，显示第${this.currentPage + 1}页`);
      }, 3000);
    },

    getMerchPriceView(merch) {
      if (merch?.products?.length === 0) {
        return merch.priceLowest;
      }
      if (merch.products.length === 1) {
        return merch.products[0].priceSale;
      }
      const primarySku = merch.products.find((v) => v.bePrimary);
      if (primarySku) {
        return primarySku.priceSale;
      }
      const minPriceSku = merch.products.reduce((min, current) => {
        return current.priceSale < min.priceSale ? current : min;
      });
      return minPriceSku?.priceSale || merch.products[0].priceSale;
    },

    getActiveSku(skus) {
      const activeSku = skus.find((v) => v.bePrimary);
      if (!activeSku) {
        const minPriceSku = skus.reduce((min, current) => {
          return current.priceSale < min.priceSale ? current : min;
        });
        return minPriceSku || skus[0];
      }
      return activeSku;
    },

    async loadMerchData() {
      let res = null;
      try {
        res = await this.$http.get('/app-api/product/repository/list/sale-top/option?topNum=20')
      } catch (error) {
      }
      if (!res || res.data.length === 0) {
        return;
      }
      const merchData = res.data;
      console.log('商品数据',merchData)
      if (merchData.total <= 0) {
        return;
      }
      merchData.records.forEach((merch) => {
        const activeMerchSku = this.getActiveSku(merch.products);
        merch.merchSkuName = activeMerchSku.merchSkuName
      });

      this.merchList = merchData.records;
      console.log('123333',this.merchList)
    },

    async loadOrganData() {
      let merchData = this.merchList;
      if(merchData.length === 0) {
        return;
      }
      const organKeys = merchData.map((m) => m.ownerOrganKey).filter((v) => v !== null);
      let res = null;
      try {
        res = await this.$http.post(ssoApiUrl + '/organ/page/open/option',{ keys: organKeys },{headers: {'csrf-token': 'unrestrictive'}})
      } catch (error) {
        debugger;
      }
      const organData = res?.data;
      if (!organData || organData.length === 0) {
        return
      }
      console.log('机构数据',organData)
      merchData.forEach((merch) => {
        const organ = organData.find((v) => v.organKey === merch.ownerOrganKey)
        if (organ) {
          this.$set(merch,'ownerOrganName', organ.organName)
        }
      });
      this.merchList = merchData;
    },

    async loadMerchCover() {
      let merchData = this.merchList;
      if(merchData.length === 0) {
        return;
      }
      const keys = merchData.map((v) => v.merchKey) || [];
      const merchKeys = merchData.map((v) => v.supplyMerchKey) || [];
      keys.push(...merchKeys);
      if (keys.length > 0) {
        const res = await this.$http.post(fileApiUrl+'/batch',{
          size: 1000,
          orders: ['order desc', 'create_time asc'],
          dkinds: ['merch','supply_merch'],
          dcodes: keys,
          duseages: ['cover'],
        },{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          }
        });
        console.log('文件数据',res)
        if (res.data.length === 0) {
          return;
        }
        const files = res.data;
        merchData.forEach((product) => {
          let fileList = files.filter((v) => v.dcode == product.supplyMerchKey && v.dkind === 'supply_merch');
          if (fileList.length === 0) {
            fileList = files.filter((v) => v.dcode === product.merchKey && v.dkind === 'merch');
          }
          if (fileList.length > 0) {
            this.$set(product,'imageUrl', `${fileApiUrl}${fileList[0].url}`)
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.merch {
  width: 100%;
  height: 100%;
  .scroll-board {
    width: 94%;
    height: calc(100% - 60px);
    margin: 0 auto;
  }
}
::v-deep .dv-scroll-board .rows .row-item {
  // margin-bottom: 10px;
  border-radius: 3px;
}

.merch-scroll {
  color: #ffffff;
  font-size: 14px;
  width: 94%;
  margin: 0 auto;
  height: calc(100% - 50px);
  .tab-hd {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 15px;
    span {
      &:nth-child(1) {
        flex: 1.5;
      }
      &:nth-child(2) {
        flex: 4;
      }
      &:nth-child(3) {
        flex: 4.5;
      }
      &:nth-child(4) {
        flex: 2.5;
        text-align: center;
      }
    }
  }
  .tab-bd {
    height: calc(100% - 40px);
    overflow: hidden;
    .row {
      margin-top: 11px;
      &:first-child {
        margin-top: 0;
      }
      .simple {
        display: flex;
        align-items: center;
        background-color: rgba(142, 201, 255, 0.1);
        height: 40px;
        span {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 1;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          &:nth-child(1) {
            flex: 1.2;
            text-align: center;
          }
          &:nth-child(2) {
            flex: 4;
            margin-right: 10px;
          }
          &:nth-child(3) {
            flex: 4.5;
            margin-right: 10px;
          }
          &:nth-child(4) {
            flex: 2.5;
            text-align: center;
          }
        }
      }

      .detail-wrap {
        background-color: rgba(142, 201, 255, 0.08);
        height: 0;
        transition: all 0.3s ease-in-out;
        overflow: hidden;
      }
      .detail {
        padding: 15px 30px;
        display: flex;
        align-items: center;
        .image {
          width: 75px;
          height: 75px;
        }
        .sku-des {
          flex: 1;
          margin-left: 20px;
          p:nth-child(2) {
            margin-top: 10px;
          }
        }
      }
      &.active {
        .detail-wrap {
          height: 105px;
        }
      }
    }
  }
}
</style>
